import { forwardRef, useContext, useRef, useState } from "react";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { storeRequester } from "App";
import { useTranslation } from "react-i18next";
import NiceModal from "@ebay/nice-modal-react";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import P from "components/P";
import { toast } from "react-toastify";

const MobileShippingInfoRow = forwardRef((props, ref) => {
    const { isMobile } = useContext(BrowserDetectContext);
    const { shippingInfo, index } = props;
    const { t } = useTranslation();
    const [isChecked, setChecked] = useState(false);
    const input = useRef();
    const { setIsAdd } = props;
    const isDefaultAddress = shippingInfo?.metadata?.default === true;

    const onDeleteClick = () => {
        const onDeleteClick = async () => {
            await storeRequester.deleteShippingAddress(shippingInfo.id);
            setIsAdd((prev) => !prev);
        };

        const onCancelClick = () => { };
        NiceModal.show("confirm", {
            message: t("confirmCartProductDelete"),
            confirmText: t("delete"),
            cancelText: t("cancel"),
            onConfirm: onDeleteClick,
            onCancel: onCancelClick,
        });
    };

    const handleSetDefaultAddress = async () => {
        try {
            await storeRequester.updateShippingAddress(shippingInfo.id, {
                ...shippingInfo,
                metadata: { default: true }
            });
            setIsAdd(prev => !prev);
            toast.success("기본 배송지로 설정되었습니다.", {
                autoClose: 1000,
                position: toast.POSITION.BOTTOM_CENTER,
            });
        } catch (error) {
            toast.error("기본 배송지 설정에 실패했습니다.", {
                autoClose: 1000,
                position: toast.POSITION.BOTTOM_CENTER,
            });
        }
    };

    const onModifyClick = () => {
        NiceModal.show("shippingInfoAddKrModal", {
            mode: "edit",
            data: shippingInfo,
            callback: onEditModalClose,
            setIsAdd: setIsAdd,
        });
    };

    const onEditModalClose = (value) => {
        if (value?.customer?.shipping_addresses) {
            if (props.shippingInfoEditCallback) {
                props.shippingInfoEditCallback(value);
            }
            toast.success("수정이 완료되었습니다.", {
                autoClose: 1000,
                position: toast.POSITION.BOTTOM_CENTER,
            });
        }
    };

    return (
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", width: "95%", border: "1px solid lightgrey", borderRadius: "5px", marginBottom: "20px", padding: "0 10px 10px 10px" }}>
            <FlexChild key={index} padding={"15px 0px"}>
                <HorizontalFlex gap={10} padding={"0 0 10px 0"} borderBottom={"1px solid lightgray"}>
                    <FlexChild>
                        <P size={16} weight={700}>
                            {shippingInfo?.name}
                        </P>
                        {isDefaultAddress && (
                            <div style={{
                                display: "inline-flex",
                                padding: "4px 8px",
                                marginLeft: "5px",
                                backgroundColor: "var(--main-color)",
                                color: "white",
                                borderRadius: "4px",
                                fontSize: "14px",
                                width: "fit-content"
                            }}>
                                기본배송지
                            </div>
                        )}
                    </FlexChild>
                    <FlexChild width={"max-content"} justifyContent={"flex-end"} alignItems={"flex-end"}>
                        <P
                            onClick={onModifyClick}
                            cursor
                            borderRadius={"3px"}
                            size={"10pt"}
                            border={"1px solid #999"}
                            padding={"2px 15px"}
                        >
                            수정
                        </P>
                    </FlexChild>
                    <FlexChild width={"max-content"} justifyContent={"flex-end"} alignItems={"flex-end"}>
                        <P
                            onClick={() => onDeleteClick(index)}
                            color={"white"}
                            backgroundColor={"var(--main-color)"}
                            cursor
                            borderRadius={"3px"}
                            size={"10pt"}
                            border={"1px solid transperent"}
                            padding={"2px 15px"}
                        >
                            삭제
                        </P>
                    </FlexChild>
                    {!isDefaultAddress && (
                        <FlexChild width={"max-content"} justifyContent={"flex-end"} alignItems={"flex-end"}>
                            <P
                                onClick={handleSetDefaultAddress}
                                cursor
                                borderRadius={"3px"}
                                size={"10pt"}
                                border={"1px solid #999"}
                                padding={"2px 15px"}
                            >
                                기본배송지 설정
                            </P>
                        </FlexChild>
                    )}
                </HorizontalFlex>
            </FlexChild>
            <FlexChild alignItems={"flex-start"}>
                <P>{shippingInfo?.first_name}</P>
            </FlexChild>
            <FlexChild alignItems={"flex-start"}>
                <P>{shippingInfo?.address_1} {shippingInfo?.address_2} {"("}{shippingInfo?.postal_code}{")"}</P>
            </FlexChild>
            <FlexChild alignItems={"flex-start"}>
                <P>{shippingInfo?.phone}</P>
            </FlexChild>
        </div>
    );
});

export default MobileShippingInfoRow;